import { lazy } from "react";

export const BackButton = lazy(() => import("./BackButton"));
export const BenefitsSection = lazy(() => import("./BenefitsSection"));
export const Button = lazy(() => import("./Button"));
export const ContentSection = lazy(() => import("./ContentSection"));
export const DynamicContentSection = lazy(() => import("./DynamicContentSection"));
export const FormSection = lazy(() => import("./FormSection"));
export const GrowthSection = lazy(() => import("./GrowthSection"));
export const Hero = lazy(() => import("./Hero"));
export const HomeHero = lazy(() => import("./HomeHero"));
export const ImageCarousel = lazy(() => import("./ImageCarousel"));
export const JobCard = lazy(() => import("./JobCard"));
export const JoinOurCommunity = lazy(() => import("./JoinOurCommunity"));
export const ProjectCard = lazy(() => import("./ProjectCard"));
export const ProjectsSection = lazy(() => import("./ProjectsSection"));
export const SeoHead = lazy(() => import("./SeoHead"));
export const VideoSection = lazy(() => import("./VideoSection"));
export const BlogSection = lazy(() => import("./BlogSection"));
export const Placeholder = lazy(() => import("./Placeholder"));
export const Collapsibles = lazy(() => import("./Collapsibles"));
export const LocationSection = lazy(() => import("./LocationSection"));
export const SolutionSection = lazy(() => import("./SolutionSection"));
export const SolutionSection2 = lazy(() => import("./SolutionSection2"));
export const ThreexTwoSolutionSection = lazy(() => import("./ThreexTwoSolutionSection"));
export const PracticeSection = lazy(() => import("./PracticeSection"));
export const IconListSection = lazy(() => import("./IconListSection"));
export const IconOnlySection = lazy(() => import("./IconOnlySection"));
export const TeamSection = lazy(() => import("./TeamSection"));
export const CaseStudySection = lazy(() => import("./CaseStudySection"));
export const QuoteSlider = lazy(() => import("./QuoteSlider"));
export const MissionCritical = lazy(() => import("./MissionCritical"));
export const GlobalCoverage = lazy(() => import("./GlobalCoverage"));
export const SectorSection = lazy(() => import("./SectorSection"));
export const ServiceBenefit = lazy(() => import("./ServiceBenefit"));
export const WorkWithUs = lazy(() => import("./WorkWithUs"));
export const GoalSection = lazy(() => import("./GoalSection"));
export const OfferSection = lazy(() => import("./OfferSection"));
export const PlainCardSection = lazy(() => import("./PlainCardSection"));
export const ReflectionSection = lazy(() => import("./ReflectionSection"));
export const EventPodcastSection = lazy(() => import("./EventPodcastSection"));
export const HorizontalImageTextSection = lazy(() => import("./HorizontalImageTextSection"));
export const VerticalImageTextSection = lazy(() => import("./VerticalImageTextSection"));
export const Text = lazy(() => import("./Shared/Text"));
export const Video = lazy(() => import("./Shared/Video"));
export const PeopleSection = lazy(() => import("./PeopleSection"));
export const CommunitySection = lazy(() => import("./CommunitySection"));
export const InsightSection = lazy(() => import("./InsightSection"));
export const Csr = lazy(() => import("./Csr"));
export const MarketSection = lazy(() => import("./MarketSection"));
// export const InsightInformedSection = lazy(() => import("./InsightInformedSection"));
//export const CsrSection = lazy(() => import("./CsrSection"));
